<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-button-group size="lg" class="rfx-status-bar">
            <b-button 
                v-for="stage in stages" 
                :key="stage.key" 
                :variant="stage.key === activeStage ? 'sharp-' + stage.baseVariant : 'sharp-secondary'"
                :disabled="!currentEnabledStages.includes(stage.key)"
                class="font-size-80 text-uppercase"
                :class="{'active-stage': stage.key === activeStage}"
                v-b-tooltip.hover.d500
                :title="stage.text"
                @click="setActiveStage(stage.key)"
            >
                {{ stage.label }}
            </b-button>
        </b-button-group>

        <ol class="w-100 border rounded-lg d-flex list-unstyled" style="height: 70px;">
            <li 
                v-for="(stage, index) in stages"
                :key="stage.key"
                class="position-relative d-flex justify-content-center align-items-center"
                style="flex-basis: 0%; flex-grow: 1; flex-shrink: 1; padding-right: 20px; padding-left: 10px;"
            >
                <div class="">
                    <div class="font-weight-bold">{{ stage.label }}</div>
                    <div class="small text-muted">{{ stage.text }}</div>
                </div>
                
                <div 
                    v-if="(index + 1) < stages.length"
                    class="d-none d-md-block position-absolute h-100" style="top: 0; right: 0; width: 20px;" aria-hidden="true"
                >
                    <svg class="h-100 w-100 text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                        <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
                    </svg>
                </div>

            </li>
        </ol>
        
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'RfxStatusBar',
    components: {},
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            activeStage: 'open',
            currentEnabledStages: [],
            stages: [  // the enabledStages here may not be correct... revisit if needed
                {
                    key: 'draft',
                    label: 'Draft',
                    text: 'RFx is being prepared',
                    baseVariant: 'dark',
                    enabledStages: ['open', 'closed', 'awarded', 'cancelled', 'archived'],
                },
                {
                    key: 'open',
                    label: 'Open',
                    text: 'Open for vendor submissions',
                    baseVariant: 'success',
                    enabledStages: ['draft', 'review', 'closed', 'awarded', 'cancelled', 'archived'],
                },
                {
                    key: 'review',
                    label: 'Review',
                    text: 'Submissions under internal review',
                    baseVariant: 'info',
                    enabledStages: ['draft', 'open', 'closed', 'awarded', 'cancelled', 'archived'],
                },
                {
                    key: 'closed',
                    label: 'Closed',
                    text: 'Event is closed',
                    baseVariant: 'danger',
                    enabledStages: ['draft', 'open', 'review', 'closed', 'cancelled', 'archived'],
                },
                {
                    key: 'awarded',
                    label: 'Awarded',
                    text: 'Event is closed and business has been awarded',
                    baseVariant: 'primary',
                    enabledStages: ['draft', 'open', 'review', 'closed', 'cancelled', 'archived'],
                },
                {
                    key: 'cancelled',
                    label: 'Cancelled',
                    text: 'Event is closed and cancelled',
                    baseVariant: 'danger',
                    enabledStages: ['draft', 'open', 'closed', 'review', 'awarded', 'archived'],
                },
                {
                    key: 'archived',
                    label: 'Archived',
                    text: 'Event is archived and hidden',
                    baseVariant: 'warning',
                    enabledStages: ['draft', 'open', 'closed', 'awarded', 'cancelled', 'cancelled'],
                },
            ]
        }
    },
    computed: {
    },
    mounted: function() {
        this.setActiveStage('open');
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        setActiveStage: function(stageKey) {
            this.activeStage = stageKey;
            let enabled = this.stages.find(stage => stage.key === stageKey).enabledStages;
            let cloned = cloneDeep(enabled);
            cloned.push(stageKey);  // add the current stage so it isn't disabled
            this.currentEnabledStages = cloned;
        }

    }
}
</script>

<style lang="scss">

.rfx-status-bar {
    button {
        width: 120px;
        &.active-stage {
            transform: scale(1.1);
            z-index: 10;
            //border-radius: 5px !important;
        }
    }
}

</style>